module.exports = __webpack_public_path__ + "img/ricelog_pinicon_072.e3812719.png";